import { getActiveBuildings } from "./index24.js";
import { CalcAnatomyEntrances } from "./index173.js";
const pipeCalcAnatomyEntrances = ([parent, { buildingIds, aggProps }]) => {
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		CalcAnatomyEntrances(building.data.anatomy);
	}
	return [parent, void 0];
};
export { pipeCalcAnatomyEntrances };

//# sourceMappingURL=index174.js.map